module.exports = __webpack_public_path__ + "img/icon-building.7c6caebd.svg";